export const accountsRoot = '/private/accounts';
export const accountListingsRoot = '/private/accountListings';
export const plansRoot = '/private/plans';
export const LD_API_VERSION = '20240415';
